module.exports = __webpack_public_path__ + "assets/img/sau.238dde72.png";